/**
 * <nocturne-quiz> — three questions, then one telescope recommendation.
 * Answers map to a result key; each key has a <template data-key> rendered by Liquid from the section blocks.
 */
(() => {
  if (customElements.get('nocturne-quiz')) return;

  function resolve({ who, want, budget }) {
    if (who === 'enfant') return 'enfant';
    if (want === 'connecte') {
      if (budget === 'max') return 'connecte-premium';
      if (budget === '800') return 'connecte';
      return 'photo';
    }
    if (want === 'photo') return budget === '150' ? 'photo-mini' : 'photo';
    if (want === 'galaxies' || who === 'passionne') return budget === '150' || budget === '350' ? 'debutant-plus' : 'passionne';
    return budget === '150' ? 'debutant-mini' : 'debutant';
  }

  class NocturneQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.resultSlot = this.querySelector('[data-result]');
      this.bar = this.querySelector('[data-progress]');
      this.back = this.querySelector('[data-back]');
      this.answers = {};
      this.index = 0;
      this.addEventListener('click', (e) => this.onClick(e));
      this.show(0);
    }

    onClick(e) {
      const answer = e.target.closest('[data-answer]');
      if (answer) {
        const step = answer.closest('[data-step]');
        step.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', String(b === answer)));
        this.answers[step.dataset.step] = answer.dataset.answer;
        this.burst(answer, 6);
        setTimeout(() => (this.index < this.steps.length - 1 ? this.show(this.index + 1) : this.finish()), 280);
        return;
      }
      if (e.target.closest('[data-back]')) this.show(Math.max(this.index - 1, 0));
      if (e.target.closest('[data-restart]')) {
        this.answers = {};
        this.steps.forEach((s) => s.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false')));
        this.show(0);
      }
    }

    show(i) {
      this.index = i;
      this.resultSlot.hidden = true;
      this.resultSlot.innerHTML = '';
      this.steps.forEach((s, n) => {
        s.hidden = n !== i;
        s.classList.toggle('is-active', n === i);
      });
      this.back.hidden = i === 0;
      this.bar.style.transform = `scaleX(${(i + 1) / (this.steps.length + 1)})`;
      this.steps[i].querySelector('legend, h3')?.focus?.({ preventScroll: true });
    }

    finish() {
      const key = resolve(this.answers);
      const tpl = this.querySelector(`template[data-key="${key}"]`) || this.querySelector('template[data-key]');
      this.steps.forEach((s) => (s.hidden = true));
      this.back.hidden = true;
      this.bar.style.transform = 'scaleX(1)';
      this.resultSlot.hidden = false;
      if (tpl) this.resultSlot.append(tpl.content.cloneNode(true));
      this.resultSlot.classList.remove('is-in');
      requestAnimationFrame(() => this.resultSlot.classList.add('is-in'));
      this.burst(this.resultSlot, 24);
    }

    burst(el, count) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const r = el.getBoundingClientRect();
      const host = this.getBoundingClientRect();
      for (let i = 0; i < count; i++) {
        const s = document.createElement('span');
        s.className = 'nx-quiz__spark';
        s.textContent = '✦';
        const angle = Math.random() * Math.PI * 2;
        const dist = 30 + Math.random() * (count > 10 ? 160 : 60);
        s.style.left = `${r.left - host.left + r.width / 2}px`;
        s.style.top = `${r.top - host.top + Math.min(r.height / 2, 120)}px`;
        s.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
        s.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
        s.style.setProperty('--s', (0.6 + Math.random()).toFixed(2));
        this.append(s);
        s.addEventListener('animationend', () => s.remove());
      }
    }
  }

  customElements.define('nocturne-quiz', NocturneQuiz);
})();
